export default __webpack_public_path__ + "static/media/login-slide-1.e9cf59f5.svg";